import { CSSProperties, SyntheticEvent, useCallback, useEffect, useRef, useState } from 'react';
import { User } from 'firebase/auth';
import { AuthProvider } from '../contexts/authContext';
import AuthPage from '../pages/auth';
import { addAlbumPhoto, getAlbumPhotos } from '../firestore/db';
import useDrivePicker from 'react-google-drive-picker'
import { CallbackDoc } from 'react-google-drive-picker/dist/typeDefs';
import {getAlbum, deleteAlbumPhoto, updateAlbumPhotoDescription} from '../firestore/db';
//styles
import "../styles/album.css";
import { Album, AlbumPhoto } from '../firestore/firestore-types';
import { Timestamp } from 'firebase/firestore';
import { DEFAULT_ALBUM_COVER_URL, normalizePhotoUrl, resolveImageUrl } from '../utils/image';
interface albumProps {
    user: User | null;
    albumOwner: string; //uid
    albumId: string; //doc id of album, id field equals this
}
const AlbumPage = (props: albumProps) => {

const [userCanAccessAlbum, setUserCanAccessAlbum] = useState(false);
const [openPicker, authResponse] = useDrivePicker();  
const [data, setData] = useState<CallbackDoc[] | null>(null);
const [album, setAlbum] = useState<Album | null>(null); //album object from firestore
const [publicPreviewUrl, setPublicPreviewUrl] = useState("");
const [isAddingPublicUrl, setIsAddingPublicUrl] = useState(false);
const [editingPhotoKey, setEditingPhotoKey] = useState<string | null>(null);
const [editingDescription, setEditingDescription] = useState("");
const [isCoarsePointer, setIsCoarsePointer] = useState(false);
const polaroidLayoutRef = useRef<Record<string, {
    tilt: number;
    pinX: number;
    pinY: number;
    offsetX: number;
    offsetY: number;
    stackOffset: number;
    cardBasis: string;
}>>({});

useEffect(() => {
    setIsCoarsePointer(window.matchMedia("(pointer: coarse)").matches);
}, [])

const albumId = props.albumId;

    const handleOpenPicker = () => {
        openPicker({
        clientId: "89038291387-n2aos6dtahid3b0ai9ds0uhqbqrtss91.apps.googleusercontent.com",
        developerKey: "AIzaSyD8hAEGTpxTyP2bdRvj95CRkHr4vap4HT8",
        viewId: "DOCS",
        token: authResponse?.access_token,
        showUploadView: true,
        showUploadFolders: true,
        supportDrives: true,
        multiselect: true,
        callbackFunction: (data) => {
            if (data.action === 'cancel') {
            console.log('drive : User clicked cancel/close button')
            }
            if (data.action === 'loaded') {
            console.log('drive : Picker loaded successfully')
            }
            if (data.action === 'authed') {
            console.log('drive : User authenticated successfully')
            }
            if (data.action === 'picked') {
            console.log('drive : User selected files/folders', data.docs)
            setData(data.docs)
            }
            
        },
        
        })
    }

    useEffect(() => {
        if (props.user !== null && props.albumId !== null) {
            console.log("user and album id is not null: ", props.user?.uid, props.albumId);
        getAlbum(props.albumOwner, props.albumId, props.user.email!).then((doc) => {
            if (doc !== undefined && doc !== "nosuchalbum" && doc !== "notowner") {
                setAlbum(doc);
            } else if (doc === "nosuchalbum") {
                console.log("no such album");
                setAlbum(null);
            } else if (doc === "notowner") {
                console.log("not owner");
                setAlbum(null);
            } else if (doc === undefined){
                console.log("doc is undefined");
                setAlbum(null);
            }
        })
        } else {
            console.log("user or album id is null");
        }
    }, [props.user, props.albumId, props.albumOwner])

    useEffect(() => {
        getAlbumPhotos(props.user?.uid!, props.albumId, props.user?.email!).then((docs) => {
            console.log("getAlbumPhotos : ",docs);
            if (docs && docs !== undefined && docs!== "nosuchalbum" && docs !== "notowner" && docs.length > 0){
                setAlbumPhotos(docs);
            } else if (docs === "nosuchalbum") {
                console.log("no such album");
                setAlbumPhotos([]);
            } else if (docs === "notowner") {
                console.log("not owner");
                setAlbumPhotos([]);
            } else {
                console.log("no photos in album");
                setAlbumPhotos([]);
            }

        })
    }, [props.user, props.albumId])

    useEffect(() => {
        // check if user can access album by checking if user is in album's collaborators array, sharedwith array , is owner or if album is public
        if (props.user !== null) {
            if (props.albumOwner === props.user.uid) {
                setUserCanAccessAlbum(true);
                console.log("user is owner");
            } else {
                if (album !== null) {
                    if (album.collaborators.includes(props.user.email!)) {
                        setUserCanAccessAlbum(true);
                        console.log("user is a collaborator");
                    } else if (album.sharedWith.includes(props.user.email!)) {
                        setUserCanAccessAlbum(true);
                        console.log("album is shared with user");
                    } else if (album.isPublic) {
                        setUserCanAccessAlbum(true);
                        console.log("album is public");
                    } else {
                        setUserCanAccessAlbum(false);
                        console.log("user cannot access album");
                    }
                } else {
                    setUserCanAccessAlbum(false);
                    console.log("user cannot access album because album is null");
                }
            }
        } else {
            console.log("user is null");
            setUserCanAccessAlbum(false);
            console.log("user cannot access album");
        }

    }, [album, props.user, props.albumOwner])

    const addExternalPhoto = useCallback(async (rawUrl: string, photoName: string) => {
        if (!props.user) {
            return;
        }

        const photoUrl = normalizePhotoUrl(rawUrl);
        if (!photoUrl) {
            return;
        }

        const result = await addAlbumPhoto(
            props.user.uid,
            albumId,
            photoName,
            photoUrl,
            "",
            props.user.displayName!,
            props.user.email!,
            props.user.photoURL!,
            undefined,
            "$optional_date_here"
        );

        if (result === "success") {
            setAlbumPhotos((currentPhotos) => ([...currentPhotos, {
                name: photoName,
                url: photoUrl,
                description: "",
                created: Timestamp.now(),
                date: "",
                uploader : props.user?.displayName!,
                uploaderPhotoUrl: props.user?.photoURL!,
                storagePath: rawUrl,
            }]));
        }
    }, [albumId, props.user])

    useEffect(() => {
        if (props.user !== null && data !== null) {
            data.forEach((doc) => {
                const fallbackName = `drive-photo-${Date.now()}`;
                addExternalPhoto(doc.url || doc.embedUrl || "", doc.name || fallbackName);
            });
        }
    }, [addExternalPhoto, data, props.user])

    const [albumPhotos, setAlbumPhotos] = useState<AlbumPhoto[]>([]);

    const handleAddPublicPreviewUrl = async () => {
        if (!publicPreviewUrl.trim()) {
            return;
        }

        setIsAddingPublicUrl(true);
        const linkName = `linked-photo-${Date.now()}`;
        await addExternalPhoto(publicPreviewUrl.trim(), linkName);
        setPublicPreviewUrl("");
        setIsAddingPublicUrl(false);
    }

    const handleDeletePhoto = (photo: AlbumPhoto) => {
        deleteAlbumPhoto(props.user!.uid, albumId, photo, props.user?.email!).then((r) => {
            if (r === "nosuchalbum") {
                console.log("no such album");
            } else if (r === "notowner") {
                console.log("not owner");
            } else if (r === "success") {
            console.log(`file ${photo.name} deleted from album ${albumId}`);
            setAlbumPhotos((currentPhotos) => currentPhotos.filter((p) => p.url !== photo.url));
            }
        }
        )
    }

    const getPhotoKey = (photo: AlbumPhoto, index: number) => `${photo.url}-${photo.name}-${index}`;

    const startEditingDescription = (photo: AlbumPhoto, index: number) => {
        setEditingPhotoKey(getPhotoKey(photo, index));
        setEditingDescription(photo.description || "");
    }

    const saveEditingDescription = async (photo: AlbumPhoto, index: number) => {
        if (!props.user) {
            return;
        }

        const nextDescription = editingDescription.trim();
        const result = await updateAlbumPhotoDescription(
            props.user.uid,
            albumId,
            props.user.email!,
            photo,
            nextDescription
        );

        if (result === "success") {
            setAlbumPhotos((currentPhotos) => currentPhotos.map((photoInState, stateIndex) => {
                if (stateIndex === index) {
                    return {
                        ...photoInState,
                        description: nextDescription,
                    };
                }

                return photoInState;
            }));
        }

        setEditingPhotoKey(null);
    }

    const openPhotoModal = (photo: AlbumPhoto) => {
        const imageUrl = resolveImageUrl(photo.url, DEFAULT_ALBUM_COVER_URL);
        document.getElementById("modal")!.style.display = "flex";
        document.getElementById("modalImage")!.setAttribute("src", imageUrl);
        document.getElementById("modalDescription")!.innerHTML = photo.description!;
    }

    const handlePhotoError = (event: SyntheticEvent<HTMLImageElement>) => {
        if (event.currentTarget.dataset.fallbackApplied === "true") {
            event.currentTarget.src = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
            return;
        }

        event.currentTarget.dataset.fallbackApplied = "true";
        event.currentTarget.src = DEFAULT_ALBUM_COVER_URL;
    }

    const getPolaroidStyle = (photoKey: string): CSSProperties => {
        if (!polaroidLayoutRef.current[photoKey]) {
            const randomRange = (min: number, max: number) => Math.random() * (max - min) + min;
            const basisOptions = ["24%", "31%", "39%"];
            polaroidLayoutRef.current[photoKey] = {
                tilt: randomRange(-10.5, 10.5),
                pinX: randomRange(40, 60),
                pinY: randomRange(5, 20),
                offsetX: randomRange(-8, 8),
                offsetY: randomRange(-9, 9),
                stackOffset: randomRange(-5, 9),
                cardBasis: basisOptions[Math.floor(Math.random() * basisOptions.length)],
            };
        }

        const layout = polaroidLayoutRef.current[photoKey];
        return {
            "--tilt": `${layout.tilt.toFixed(2)}deg`,
            "--pin-x": `${layout.pinX.toFixed(2)}%`,
            "--pin-y": `${layout.pinY.toFixed(2)}%`,
            "--offset-x": `${layout.offsetX.toFixed(2)}px`,
            "--offset-y": `${layout.offsetY.toFixed(2)}px`,
            "--stack-offset": `${layout.stackOffset.toFixed(2)}px`,
            "--card-basis": layout.cardBasis,
        } as CSSProperties;
    }

    if (props.user !== null && (userCanAccessAlbum)) {
        if (album !== null) {
        return (
            <>
                <div className='album-page-wrapper'>
                    <div className='top-bar'>
                        <div className='nav-go-back'>
                            <a href="/">&larr; Hub</a>
                        </div>
                        <div className='album-cover-photo'>
                            <img src={resolveImageUrl(album.photoUrl, DEFAULT_ALBUM_COVER_URL)} alt="album cover" style={{maxWidth:"20vw"}} onError={handlePhotoError} />
                        </div>
                        <div className='album-info'>
                            <div className='album-title'>
                                <h1>{album.name}</h1>
                            </div>
                            <div className='album-description'>
                                <p>{album.description}</p>
                            </div>
                        </div>
                    </div>
                    <div className="modal" id="modal">
                        <div className="modal-content">
                            <span className="close-btn" onClick={() => {document.getElementById("modal")!.style.display = "none"}}>&times;</span>
                            <img id="modalImage" alt="Enlarged Polaroid"/>

                            {/* <iframe src="" id="modalImage" title='asd'></iframe> */}
                                <div id="modalDescription" className="description"></div>
                        </div>
                    </div>
                    <div className="header" style={{textAlign: "center"}}>
                        <h1>{album.name}</h1>
                    </div>
                    <div className="album-actions">
                        <button className="album-action-btn" onClick={() => handleOpenPicker()}>Add From Drive</button>
                        <div className="album-public-link-form">
                            <input
                                type="url"
                                placeholder="Paste public preview/image URL"
                                value={publicPreviewUrl}
                                onChange={(e) => setPublicPreviewUrl(e.target.value)}
                            />
                            <button className="album-action-btn" onClick={handleAddPublicPreviewUrl} disabled={isAddingPublicUrl}>
                                {isAddingPublicUrl ? "Adding..." : "Add By Link"}
                            </button>
                        </div>
                        <p className="album-actions-note">Direct device upload is currently disabled because Firebase Storage is unavailable.</p>
                    </div>
                    <div className="bulletin-board" id="bulletinBoard">
                        {albumPhotos.map((photo, index) => {
                            const photoUrl = resolveImageUrl(photo.url, DEFAULT_ALBUM_COVER_URL);
                            const photoKey = getPhotoKey(photo, index);
                            const isEditing = editingPhotoKey === photoKey;
                            return (
                                <div className="polaroid" key={`${photo.url}-${photo.name}-${index}`} style={getPolaroidStyle(photoKey)}>
                                    <span className="polaroid-pin" aria-hidden="true"></span>
                                    <div className="polaroid-photo-wrap">
                                        <img
                                            src={photoUrl}
                                            alt=""
                                            onError={handlePhotoError}
                                            onClick={() => openPhotoModal(photo)}
                                        />
                                    </div>
                                    {isEditing ? (
                                        <input
                                            className="description-input"
                                            autoFocus
                                            value={editingDescription}
                                            onChange={(e) => setEditingDescription(e.target.value)}
                                            onBlur={() => saveEditingDescription(photo, index)}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    saveEditingDescription(photo, index);
                                                }
                                                if (e.key === "Escape") {
                                                    setEditingPhotoKey(null);
                                                }
                                            }}
                                        />
                                    ) : (
                                        <button
                                            className="description-text"
                                            onClick={() => {
                                                if (!isCoarsePointer) {
                                                    startEditingDescription(photo, index);
                                                }
                                            }}
                                        >
                                            {photo.description || "Tap to add a title"}
                                        </button>
                                    )}
                                    <div>
                                        <button className="edit-description-btn" onClick={() => startEditingDescription(photo, index)}>Edit</button>
                                        <button className="delete-photo-button" onClick={() => handleDeletePhoto(photo)}>Remove</button>
                                    </div>
                                </div>
                            )
                        })}
                        {/* <div className="polaroid" id="polaroid">
                            <img src="" />
                            <div className="description" id="description"></div>
                        </div> */}
                    </div>
                </div>
            </>
        ) } else return (
            <div> album doesnt exist</div>
        )
    } else return (
        <>
            <h1>NOT LOGGED IN</h1>
            <AuthProvider>
                <AuthPage user={props.user} />
            </AuthProvider>
        </>
    )
}

export default AlbumPage;